/*ěščřžýáíéúů*/
(function ($) {
	$('.informace-filter__checkbox').on('click', function (e) {
		e.preventDefault();
		var $checkbox = $(this);
		var $input = $checkbox.find('.informace-filter__input');

		if ( $checkbox.hasClass('informace-filter__checkbox--checked') ) {
			$input.prop('checked', false);
			$checkbox.removeClass('informace-filter__checkbox--checked');
		} else {
			$input.prop('checked', true);
			$checkbox.addClass('informace-filter__checkbox--checked');
		}
	});
})(jQuery);
